import React from 'react';
import { EntityModalPlaceholder } from './EntityModalPlaceholder';
import './entity_placeholder.scss';
import { ModalScrollableBody } from '../modal';

type Props = {
  isLoading: boolean;
  children: React.ReactNode;
};

export function EntityModalLoader({ isLoading, children }: Props) {
  return (
    <ModalScrollableBody>
      {isLoading
        ? new Array(3).fill({}).map((x, index) => (
            <div
              className="entity-placeholder__list-item"
              key={index.toString()}
            >
              <EntityModalPlaceholder />
            </div>
          ))
        : children}
    </ModalScrollableBody>
  );
}
